import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=63a063ea&scoped=true&"
import script from "./UserPreferences.vue?vue&type=script&lang=js&"
export * from "./UserPreferences.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=63a063ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a063ea",
  null
  
)

export default component.exports